import React, { memo, useState } from "react";
import * as Yup from "yup";
import dayjs from "dayjs";
import { useFormik } from "formik";
import { validators, formats } from "investira.sdk";
import {
  Stack,
  Box,
  Card,
  Typography,
  LoadingButton,
  Divider,
} from "investira.react.components";
import {
  DatePicker,
  InputAsync,
  PessoaImage,
  CardInfo,
  ExcelLikeInput,
} from "../../components/molecules";
import { BaseTemplate } from "../../components/templates";
import { VALIDATIONS } from "../../const";
import services from "../../services";
import withResponseHandling from "../../hoc/withResponseHandling";

const CorrelacaoCarteira = memo((props) => {
  const [result, setResult] = useState({});

  const VALIDATION_SCHEMA = Yup.object().shape({
    isin: Yup.string().nullable(),
    indicador_id: Yup.string().nullable(),
    ativo_id: Yup.string().nullable(),
    ticker: Yup.string().nullable(),
    data: Yup.date()
      .required(VALIDATIONS.REQUIRED)
      .typeError(`${VALIDATIONS.INVALID_DATE}`),
    dias: Yup.number().required(VALIDATIONS.REQUIRED),
  });

  const xInitialValues = {
    indicador_id: null,
    ativo_id: null,
    ticker: null,
    isin: null,
    data: dayjs(),
    dias: 8,
    incluir_variacoes: true,
  };

  const formik = useFormik({
    initialValues: xInitialValues,
    validationSchema: VALIDATION_SCHEMA,
    validateOnMount: false,
    onSubmit: (pValues, pActions) => {
      const xPayload = {
        ...pValues,
        data: dayjs(pValues.data).format("YYYY-MM-DD"),
        eventos: true,
      };

      services.consultas.correlacao(
        xPayload,
        (rRes) => {
          const xResult = rRes.data;
          setResult(xResult);
        },
        (rErr) => {
          props.responseErrorHandling(rErr);
        },
        () => {
          pActions.setSubmitting(false);
        }
      );
    },
  });

  const handleDateChange = (pFieldName, pFieldValue) => {
    formik.setFieldValue(pFieldName, pFieldValue, true);
  };

  return (
    <BaseTemplate title="Análise Carteira" maxWidth="lg">
      <Stack spacing={2}>
        <Card
          component="form"
          noValidate
          onSubmit={formik.handleSubmit}
          autoComplete="off"
        >
          <Stack px={2} py={2}></Stack>
        </Card>
      </Stack>
    </BaseTemplate>
  );
});

export default withResponseHandling(CorrelacaoCarteira);
